'use strict';

var _ = require('lodash');

var pendingCallbacks = []; // eslint-disable-line @wix/santa/no-module-state

var renderCounter = 0; // eslint-disable-line @wix/santa/no-module-state

var renderToStringCounter = 0; // eslint-disable-line @wix/santa/no-module-state

function flushPendingCallbacksIfNotRenderingAndHasPending() {
  if (pendingCallbacks.length && renderCounter === 0) {
    var copyOfPendingCallbacks = pendingCallbacks;
    pendingCallbacks = [];

    _.forEach(copyOfPendingCallbacks, function (callback) {
      callback();
    });

    flushPendingCallbacksIfNotRenderingAndHasPending();
  }
}

function finishedRendering() {
  // @ts-ignore
  this._isMounted = true;

  if (renderToStringCounter === 0) {
    renderCounter--;
    flushPendingCallbacksIfNotRenderingAndHasPending();
  }
}

function componentWillUnmount() {
  //eslint-disable-line no-unused-vars
  // @ts-ignore
  this._isMounted = false;
}

function startedRendering() {
  if (renderToStringCounter === 0) {
    renderCounter++;
  }
}

function toggleRenderToString(renderingToString) {
  renderToStringCounter += renderingToString ? 1 : -1;
}

function callAfterRenderDone(callback) {
  // @ts-ignore
  if (!this._isMounted) {
    console.error('only invoke callAfterRenderDone if the component is mounted'); //eslint-disable-line no-console

    return;
  }

  if (renderCounter === 0) {
    callback();
  } else {
    pendingCallbacks.push(callback);
  }
}
/**
 * @type {*}
 */


module.exports = {
  componentDidMount: finishedRendering,
  componentDidUpdate: finishedRendering,
  componentWillMount: startedRendering,
  componentWillUpdate: startedRendering,
  toggleRenderToString: toggleRenderToString,
  callAfterRenderDone: callAfterRenderDone
};
//# sourceMappingURL=renderDoneMixin.js.map